<template>
  <div>
    <div id="home">
      <div id="goConf" class="col col-2 pad40 borderRight">
        <h2>Manage</h2>
        <h3>YOUR <span class="lowerCase">postgresql.conf</span> CONFIGURATIONS</h3>
        <ul class="blue">
          <li>Upload your <code>postgresql.conf</code> files and manage them from your web browser.</li>
          <li>Edit, delete, validate parameters.</li>
          <li>Name and store different configurations.</li>
          <li>Download them in several formats. Or <router-link :to="'/manage/apidocs'" title="Developers">via an API</router-link>.</li>
          <li>Share publicly the configurations you want.</li>
          <li><strong>This is a free service, forever!</strong></li>
        </ul>
        <br/>

        <a v-if="loggedIn" href="/manage" class="btn" title="Configurations Management">Co.nf Management</a>
        <a v-else :href="loginUrl" class="btn" title="Sign Up / Sign In">Sign up / Sign in</a>

        <a @click="requestFile" class="btn" title="Test it! Upload file">Test it! Upload file</a>

        <a v-if="theme == 'dark'" href="/resources/videos/conf-management-dark.m4v" class="html5lightbox"><img src="/resources/images/poster/conf-management-dark-poster.jpg" alt="CO.NF Management"></a>
        <a v-else href="/resources/videos/conf-management-light.m4v" class="html5lightbox"><img src="/resources/images/poster/conf-management-light-poster.jpg" alt="CO.NF Management"></a>

         <input id="uploadConf" type="file" ref="file" @change="uploadFile" required class="hide">
      </div>

      <div id="goDoc" class="col col-2 pad40">
        <h2>Documentation</h2>
        <h3>BROWSE PARAMETERS DOCUMENTATION</h3>
        <ul class="blue">
          <li>All the documentation and help you need about all the <code>postgresql.conf</code> parameters.</li>
          <li>Covering the nine most recent versions of Postgres</li>
          <li>Available in 5 languages: <a href="/doc/en/param/" title="EN">English</a>, <a href="/doc/ja/param/" title="JA">Japanese</a>, <a href="/doc/ru/param/" title="RU">Russian</a>, <a href="/doc/zh/param/" title="ZH">Chinese</a> and <a href="/doc/fr/param/" title="FR">French</a>.</li>
          <li>Check other user's recommendations, or share yours.</li>
        </ul>
        <div class="searchHome">
          <input id="homeKeyword" v-model="keyword" autocomplete="off" type="text" placeholder="Search parameter...">
          <a href="#" class="btn" title="Search Parameter">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><path fill="#ffffff" d="M21.4,24.4l-6.3-6.3c-1.6,1-3.4,1.5-5.3,1.5c-2.6,0-5.1-1-6.9-2.9C1,14.9,0,12.4,0,9.8c0-2.6,1-5.1,2.9-6.9C4.7,1,7.2,0,9.8,0c2.6,0,5.1,1,6.9,2.9c1.8,1.8,2.9,4.3,2.9,6.9c0,1.9-0.5,3.7-1.5,5.3l6.3,6.3c0.8,0.8,0.8,2.2,0,3c0,0,0,0,0,0C24,24.8,23.4,25,22.9,25C22.3,25,21.8,24.8,21.4,24.4z M5.7,5.9c-2.3,2.3-2.3,5.9,0,8.2c0,0,0,0,0,0c1.1,1.1,2.6,1.7,4.1,1.7c1.5,0,3-0.6,4.1-1.7c2.3-2.3,2.3-5.9,0-8.2c0,0,0,0,0,0c-1.1-1.1-2.6-1.7-4.1-1.7C8.3,4.2,6.8,4.8,5.7,5.9L5.7,5.9z"/></svg>
          </a>
          <ul v-if="keyword.length" class="paramsList">
            <li class="noParams">Your request didn't match any parameters</li>
            <li v-for="param in defaultParams" v-if="!keyword.length || (keyword.length && param.name.toLowerCase().includes(keyword.toLowerCase()))">
              <a :href="siteBaseUrl + '/doc/en/param/' + param.name + '/'" :title="'View ' + param.name + ' docs'">{{ param.name }}</a>
            </li>
          </ul>
        </div>
        <div class="clearfix"></div>
        <a :href="siteBaseUrl + '/doc/en/param/'" class="btn noMargin" title="Browse all parameters">Browse all parameters</a>

        <a v-if="theme == 'dark'" href="/resources/videos/conf-doc-dark.m4v" class="html5lightbox"><img src="/resources/images/poster/conf-doc-dark-poster.jpg" alt="CO.NF Documentation Darkmode"></a>
        <a v-else href="/resources/videos/conf-doc-light.m4v" class="html5lightbox"><img src="/resources/images/poster/conf-doc-light-poster.jpg" alt="CO.NF Documentation Lightmode"></a>

      </div>

      <div class="footer borderTop textCenter">
        © 2025 <a href="https://www.ongres.com/" target="_blank" title="OnGres, Inc.">OnGres, Inc.</a>
        <!--
        <div class="social">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 20.5"><path fill="#00ADB5" d="M7.9,20.4c9.5,0,14.6-7.8,14.6-14.6c0-0.2,0-0.4,0-0.7c1-0.7,1.9-1.6,2.6-2.7c-0.9,0.4-1.9,0.7-2.9,0.8c1.1-0.6,1.9-1.7,2.3-2.8c-1,0.6-2.1,1-3.3,1.2c-1.9-2.1-5.2-2.2-7.2-0.3c-1,1-1.6,2.3-1.6,3.8c0,0.4,0,0.8,0.1,1.2C8.2,6.1,4.3,4.2,1.7,1C0.4,3.3,1.1,6.3,3.3,7.8C2.5,7.8,1.7,7.6,1,7.2v0.1c0,2.4,1.7,4.5,4.1,5c-0.4,0.1-0.9,0.2-1.3,0.2c-0.3,0-0.7,0-1-0.1c0.7,2.1,2.6,3.5,4.8,3.6c-1.8,1.4-4.1,2.2-6.4,2.2c-0.4,0-0.8,0-1.2-0.1C2.3,19.6,5.1,20.4,7.9,20.4"/></svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 23"><path fill="#00ADB5" d="M20.3,0C20.1,0,20,0.1,20,0.2l-3.2,8.5l-4.3,0l-4.3,0L5,0.2C4.9,0.1,4.8,0,4.7,0l0,0C4.5,0,4.4,0.1,4.4,0.2L0,13.8c0,0.1,0,0.3,0.1,0.4l12.2,8.8c0.1,0.1,0.3,0.1,0.4,0l12.2-8.8c0.1-0.1,0.2-0.2,0.1-0.4L20.6,0.2C20.6,0.1,20.4,0,20.3,0z"/></svg>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 24"><path fill="#00ADB5" d="M5.2,2.6C5.2,4,4,5.2,2.6,5.2S0,4,0,2.6C0,1.1,1.2,0,2.6,0C4,0,5.2,1.2,5.2,2.6C5.2,2.6,5.2,2.6,5.2,2.6z M5.2,7.3H0V24h5.2V7.3z M13.5,7.3H8.3V24h5.2v-8.7c0-4.9,6.3-5.3,6.3,0V24H25V13.4c0-8.2-9.3-7.9-11.5-3.9L13.5,7.3z"/></svg>
        </div>
        -->
      </div>

    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import store from '../store'
  import router from '../router'
  import { mixin } from '../components/mixins/mixin'


  export default {
    name: 'UploadConfig',

    mixins: [mixin],

    computed: {
      loggedIn() {
        return store.state.authToken.length
      },
      theme() {
        return store.state.theme
      }
    },

    data: function() {
      return {
        file: null,
        keyword: '',
        defaultParams: []
      }
    },

    created: function() {
      const vc = this;

      // Get doc if not already loaded
      if(typeof store.state.defaultParams["17"] !== 'undefined') {
          vc.defaultParams = store.state.defaultParams["17"]
      } else {
          axios.get(process.env.VUE_APP_API_URL+'/docs/parameters/17')
          .then( function(response){
              store.commit('setDefaultParams', { version: "17", params: response.data.params })
              vc.defaultParams = response.data.params
          }).catch(function(err) {
              if(err.response.status != 401)
                  console.log(err);
          });
      }
    },

    methods: {
      requestFile() {
        $('#uploadConf').click()
      },

      uploadFile() {
        let vc = this;

        this.file = event.target.files[0]
        const formData = new FormData()
        formData.append('file', vc.file, vc.file.name)

        axios.post(process.env.VUE_APP_API_URL+'/validate/postgresql.conf', formData)
        .then( function(response){

          store.commit('setDemoConfig', response.data);
          router.push('/manage/config/action/validate')
        }).catch(function(err) {
            console.log(err);
        });
      }

    },
    mounted: function() {
      const vc = this;

      let html5lightbox = document.createElement('script')
      html5lightbox.setAttribute('src', '/resources/js/html5lightbox/html5lightbox.js')
      document.body.appendChild(html5lightbox)
    }

  }
</script>


<style>
  li.noParams {
    display: none;
  }

  li.noParams:first-child:last-child {
    display: block;
  }

  .html5boxSeekerPlay {
    background: var(--blue) !important;
  }
</style>
